import featureFlags from "~/featureFlags";

export const logInfo = (feature: string, message: string, meta?: any) => {
  if (featureFlags.logging.global && featureFlags.logging[feature]) {
    console.log(message, { feature, ...meta });
  }
};

export const logError = (feature: string, message: string, meta?: any) => {
  if (featureFlags.logging.global && featureFlags.logging[feature]) {
    console.error(message, { feature, ...meta });
  }
};
